"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdErrorsService = void 0;
const rxjs_1 = require("rxjs");
class TpdErrorsService {
    constructor() {
        this.subject = new rxjs_1.Subject();
        this.errorMsg = new rxjs_1.Subject();
    }
    // -- To BE REMOVED but not for now please
    setSuccess(component, isLoading, success, error) {
        component.isLoading = isLoading;
        component.success = success;
        component.error = error;
        return component;
    }
    getErrorObservable() {
        return this.subject.asObservable();
    }
    sendErrorNotification(val) {
        this.subject.next(val);
    }
    getMsgObservable() {
        return this.errorMsg.asObservable();
    }
    changeMsg(val) {
        this.errorMsg.next(val);
    }
}
exports.TpdErrorsService = TpdErrorsService;
